import { createSlice } from "@reduxjs/toolkit";
import { LOADING } from "../../../types";
import { setHighlightError } from "../actions/setError";
import { setHighlightData } from "../actions/setData";
import { addHighlight } from "../actions/add";
import { deleteHighlight } from "../actions/delete";
import { toggleHighlightVisibility } from "../actions/toggleVisibility";
import { HightlightState } from "../types/state";

const initialState: HightlightState = {
  data: null,
  loading: LOADING.IDLE,
  error: null,
};

export const highlightSlice = createSlice({
  name: "highlight",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setHighlightError, (state, { payload: error }) => {
        state.error = error;
        state.loading = LOADING.IDLE;
        state.data = null;
      })
      .addCase(setHighlightData, (state, { payload: sponsors }) => {
        state.data = sponsors;
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addHighlight.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addHighlight.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(addHighlight.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(deleteHighlight.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(deleteHighlight.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(deleteHighlight.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(toggleHighlightVisibility.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(
        toggleHighlightVisibility.rejected,
        (state, { payload: error }) => {
          state.loading = LOADING.IDLE;
          state.error = error as string | null;
        },
      )
      .addCase(toggleHighlightVisibility.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      });
  },
});
